var _path, _circle, _ellipse, _ellipse2, _circle2, _ellipse3, _ellipse4, _ellipse5, _circle3, _ellipse6, _path2, _circle4, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMachine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89478 6.70424V5.50424C5.89478 5.48679 5.90891 5.47266 5.92635 5.47266H14.2842C14.3017 5.47266 14.3158 5.48679 14.3158 5.50424V6.70424C14.3158 6.72168 14.3017 6.73581 14.2842 6.73581H5.92635C5.90891 6.73581 5.89478 6.72168 5.89478 6.70424Z",
    stroke: "#212933",
    strokeWidth: 1.26316
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.73673,
    cy: 9.68472,
    r: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.73673,
    cy: 14.3156,
    rx: 0.421053,
    ry: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.73673,
    cy: 12.0011,
    rx: 0.421053,
    ry: 0.421052,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1051,
    cy: 9.68472,
    r: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1051,
    cy: 14.3156,
    rx: 0.421053,
    ry: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1051,
    cy: 12.0011,
    rx: 0.421053,
    ry: 0.421052,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4738,
    cy: 9.68472,
    rx: 0.421053,
    ry: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4738,
    cy: 14.3156,
    r: 0.421053,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4738,
    cy: 12.0011,
    rx: 0.421053,
    ry: 0.421052,
    stroke: "#212933",
    strokeWidth: 0.631579,
    strokeMiterlimit: 16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4211 2.52539H3.78953C3.0919 2.52539 2.52637 3.09093 2.52637 3.78855V16.4201C2.52637 17.1177 3.0919 17.6833 3.78952 17.6833H16.4211C17.1187 17.6833 17.6843 17.1178 17.6843 16.4201V3.78855C17.6843 3.09093 17.1187 2.52539 16.4211 2.52539Z",
    stroke: "#212933",
    strokeWidth: 1.26316
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.421,
    cy: 16.4207,
    r: 7.26316,
    fill: "white",
    stroke: "#212933",
    strokeWidth: 0.631579
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4207 18.525L16.4207 14.3145M16.4207 14.3145L14.3154 16.4197M16.4207 14.3145L18.526 16.4197",
    stroke: "#212933",
    strokeWidth: 0.842105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMachine);
export default __webpack_public_path__ + "static/media/send-machine.fb45fd5d.svg";
export { ForwardRef as ReactComponent };